export const aboutData = {
  brandIntro: {
    title: '关于蜜桃视频',
    subtitle: '发现精彩，分享快乐',
    content: `蜜桃视频成立于2020年，是一家专注于高品质视频内容分发的互联网平台。我们致力于为用户提供流畅、高清、多元化的视频观看体验，同时为创作者打造优质的创作环境和变现渠道。

经过多年的发展，蜜桃视频已经成为国内领先的视频内容平台之一，月活跃用户突破5000万，合作创作者超过100万人。我们的使命是「让每个人都有机会发现世界的精彩，分享生活的美好」。

蜜桃视频始终坚持以用户为中心，持续投入技术创新和内容建设，不断优化产品体验，努力成为用户最信赖的视频平台。`,
    imageSeq: 'about-brand',
  },
  milestones: [
    { year: '2020', event: '蜜桃视频正式上线，首批入驻创作者1000人' },
    { year: '2021', event: '月活跃用户突破1000万，完成A轮融资' },
    { year: '2022', event: '推出创作者激励计划，合作创作者突破10万' },
    { year: '2023', event: '上线4K超清播放功能，月活用户突破3000万' },
    { year: '2024', event: 'AI智能推荐系统全面升级，完成B轮融资' },
    { year: '2025', event: '月活跃用户突破5000万，内容库超过200万条' },
    { year: '2026', event: '全新界面升级，推出会员体系和创作者电商功能' },
  ],
  reputation: {
    title: '用户口碑',
    subtitle: '来自千万用户的真实评价',
    reviews: [
      {
        name: '张先生',
        role: '影视爱好者',
        avatarSeq: 'user-01',
        content: '蜜桃视频的推荐太准了！每次打开都能看到我喜欢的类型，画质也很清晰，会员价格比其他平台实惠很多。',
        rating: 5,
        date: '2026-07-20',
      },
      {
        name: '李女士',
        role: '宝妈用户',
        avatarSeq: 'user-02',
        content: '青少年模式做得很好，给孩子用很放心。可以设置观看时长和内容范围，孩子只能看适合他们年龄的内容。',
        rating: 5,
        date: '2026-07-15',
      },
      {
        name: '王先生',
        role: '内容创作者',
        avatarSeq: 'user-03',
        content: '作为创作者，蜜桃视频的流量扶持真的很给力。入驻第三个月就有十万粉丝了，收益也超出预期。',
        rating: 5,
        date: '2026-07-10',
      },
      {
        name: '赵女士',
        role: '大学生用户',
        avatarSeq: 'user-04',
        content: '界面简洁没有乱七八糟的广告，知识科普频道的内容质量很高，学习累了看看科普视频也是一种放松。',
        rating: 4,
        date: '2026-07-05',
      },
      {
        name: '陈先生',
        role: '上班族用户',
        avatarSeq: 'user-05',
        content: '离线下载功能太好用了！每天通勤路上看一集综艺，完全不卡顿。多端同步也很方便，手机没看完电脑继续看。',
        rating: 5,
        date: '2026-06-28',
      },
      {
        name: '刘女士',
        role: '音乐爱好者',
        avatarSeq: 'user-06',
        content: '音乐频道的MV画质很棒，还有无损音质选项。歌单推荐也很对我胃口，发现了不少好听的独立音乐人。',
        rating: 5,
        date: '2026-06-20',
      },
    ],
  },
  contact: {
    title: '联系我们',
    subtitle: '如有任何问题或合作意向，欢迎与我们取得联系',
    email: 'contact@mitaovideo.com',
    phone: '400-888-6666',
    address: '北京市朝阳区望京科技园A座18层',
    workingHours: '周一至周五 9:00 - 18:00',
    wechat: 'mitaovideo',
    weibo: '@蜜桃视频官方',
  },
  faqs: [
    {
      q: '蜜桃视频是否免费？',
      a: '蜜桃视频提供免费和付费两种观看模式。免费用户可观看大部分内容（含少量广告），付费会员可享受去广告、4K超清、独家内容等更多权益。',
    },
    {
      q: '如何注册蜜桃视频账号？',
      a: '您可以通过手机号、微信或邮箱快速注册蜜桃视频账号。在蜜桃视频主页点击「注册」按钮，按照提示填写信息即可完成注册。',
    },
    {
      q: '蜜桃视频支持哪些设备？',
      a: '蜜桃视频支持iOS、Android手机端，以及Web网页端和智能电视TV端。一个账号可在多个设备上使用，会员支持3台设备同时观看。',
    },
    {
      q: '如何成为蜜桃视频的创作者？',
      a: '在蜜桃视频主页注册账号后，进入「创作者中心」完成实名认证，即可开通创作者权限。新创作者可享受新人流量扶持计划。',
    },
    {
      q: '会员可以退款吗？',
      a: '蜜桃视频会员购买后7天内如未使用任何会员权益，可申请全额退款。详情请查看会员服务协议或联系客服。',
    },
  ],
};